/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IObrienPerformanceChartsViewProps } from './obrien-performance-charts';

export default (props: IObrienPerformanceChartsViewProps) => {

    const {
        row1Columns,
        row2Columns,
        row3Columns,
        row4Columns,
        row5Columns,
        row6Columns,
        row7Columns,
        row8Columns,
    } = props;

    return (
        <div className="inside-xl">
            
            <table className="sizing product-chart">
               
                {row1Columns && row1Columns.length > 0 ? (
                    <tr>
                    {row1Columns.map((row1Th, index: number) => {
                        return (
                            <th key={index}>
                                {row1Th}
                            </th>
                        );
                    })}
                    </tr>
                ) : null}
                {row2Columns && row2Columns.length > 0 ? (
                    <tr>
                    {row2Columns.map((row2Th, index: number) => {
                        return (
                            <td key={index}>
                                {row2Th}
                            </td>
                        );
                    })}
                    </tr>
                ) : null}
                {row3Columns && row3Columns.length > 0 ? (
                    <tr>
                    {row3Columns.map((row3Th, index: number) => {
                        return (
                            <td key={index}>
                                {row3Th}
                            </td>
                        );
                    })}
                    </tr>
                ) : null}
                {row4Columns && row4Columns.length > 0 ? (
                    <tr>
                    {row4Columns.map((row4Th, index: number) => {
                        return (
                            <td key={index}>
                                {row4Th}
                            </td>
                        );
                    })}
                    </tr>
                ) : null}
                {row5Columns && row5Columns.length > 0 ? (
                    <tr>
                    {row5Columns.map((row5Th, index: number) => {
                        return (
                            <td key={index}>
                                {row5Th}
                            </td>
                        );
                    })}
                    </tr>
                ) : null}
                {row6Columns && row6Columns.length > 0 ? (
                    <tr>
                    {row6Columns.map((row6Th, index: number) => {
                        return (
                            <td key={index}>
                                {row6Th}
                            </td>
                        );
                    })}
                    </tr>
                ) : null}
                {row7Columns && row7Columns.length > 0 ? (
                    <tr>
                    {row7Columns.map((row7Th, index: number) => {
                        return (
                            <td key={index}>
                                {row7Th}
                            </td>
                        );
                    })}
                    </tr>
                ) : null}
                {row8Columns && row8Columns.length > 0 ? (
                    <tr>
                    {row8Columns.map((row8Th, index: number) => {
                        return (
                            <td key={index}>
                                {row8Th}
                            </td>
                        );
                    })}
                    </tr>
                ) : null}
            </table>


        </div>
    );
};
